import { X } from "lucide-react";
import { priceRanges } from "@/mocks/products";
import { useScrollLock } from "@/utils/useScrollLock";
import { colorHex } from "@/utils/variants";

export interface FilterOption {
  id: string;
  label: string;
}

interface FilterDrawerProps {
  open: boolean;
  onClose: () => void;
  selectedPrices: string[];
  onPriceToggle: (id: string) => void;
  attributeFilters: Record<string, FilterOption[]>;
  selectedAttributes: Record<string, string[]>;
  onAttributeToggle: (attributeName: string, valueId: string) => void;
  hasActiveFilters: boolean;
  onClear: () => void;
  resultCount: number;
}

function Option({ label, checked, swatch, onToggle }: { label: string; checked: boolean; swatch?: string; onToggle: () => void }) {
  return (
    <button type="button" role="checkbox" aria-checked={checked} className={`bz-filter-option ${checked ? "is-on" : ""}`} onClick={onToggle}>
      {swatch && <i style={{ background: swatch }} aria-hidden="true" />}
      {label}
    </button>
  );
}

export default function FilterDrawer({ open, onClose, selectedPrices, onPriceToggle, attributeFilters, selectedAttributes, onAttributeToggle, hasActiveFilters, onClear, resultCount }: FilterDrawerProps) {
  useScrollLock(open);
  return (
    <>
      <div onClick={onClose} className={`bz-scrim ${open ? "is-open" : ""}`}></div>
      <aside className={`bz-side bz-side-left ${open ? "is-open" : ""}`} aria-label="Filtros" aria-hidden={!open}>
        <div className="bz-side-head">
          <h2>Filtrar</h2>
          <button type="button" className="bz-icon-btn" aria-label="Fechar filtros" onClick={onClose}>
            <X size={20} strokeWidth={1.25} aria-hidden="true" />
          </button>
        </div>
        <div className="bz-side-body">
          {Object.entries(attributeFilters).map(([attributeName, options]) =>
            options.length > 0 ? (
              <section key={attributeName} className="bz-filter-group">
                <h3>{attributeName}</h3>
                <div>
                  {options.map((option) => (
                    <Option
                      key={option.id}
                      label={option.label}
                      swatch={/^(cor|cores|color)$/i.test(attributeName.trim()) ? colorHex(option.label) : undefined}
                      checked={(selectedAttributes[attributeName] ?? []).includes(option.id)}
                      onToggle={() => onAttributeToggle(attributeName, option.id)}
                    />
                  ))}
                </div>
              </section>
            ) : null
          )}
          <section className="bz-filter-group">
            <h3>Preço</h3>
            <div>
              {priceRanges.map((range) => (
                <Option key={range.id} label={range.label} checked={selectedPrices.includes(range.id)} onToggle={() => onPriceToggle(range.id)} />
              ))}
            </div>
          </section>
        </div>
        <div className="bz-side-foot">
          <button type="button" className="bz-btn" onClick={onClose}>Ver {resultCount} {resultCount === 1 ? "peça" : "peças"}</button>
          {hasActiveFilters && <button type="button" className="bz-text-btn bz-clear" onClick={onClear}>Limpar filtros</button>}
        </div>
      </aside>
    </>
  );
}
